module.exports = __webpack_public_path__ + "img/no_filter_outlined_32.ac68e427.svg";